// extracted by mini-css-extract-plugin
export default {"container":"container_container__68-Cd","containerAlt":"container_containerAlt__BK8Ux"};